import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PrivateRoute } from '../components';
import Plans from './Plans';
import ViewPlan from './plans/ViewPlan';
import EditPlan from './plans/EditPlan';
import NewPlan from './plans/NewPlan';
import Regions from './plans/Regions';
import NewRegion from './plans/regions/NewRegion';
import Compare from './plans/Compare';

const propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

function PlansRouter({ match }) {
  return (
    <Switch>
      <Route exact path={match.path} component={Plans} />
      <PrivateRoute exact path={`${match.path}/new`} component={NewPlan} />
      <PrivateRoute exact path={`${match.path}/regions`} component={Regions} />
      <PrivateRoute exact path={`${match.path}/regions/new`} component={NewRegion} />
      <Route exact path={`${match.path}/compare`} component={Compare} />
      <Route exact path={`${match.path}/:planId`} component={ViewPlan} />
      <PrivateRoute exact path={`${match.path}/:planId/edit`} component={EditPlan} />
    </Switch>
  );
}

PlansRouter.propTypes = propTypes;
export default PlansRouter;
